export default __webpack_public_path__ + "static/media/bad-bg.b851f355.svg";